export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const NOTATION = 10 ** 18;
export const NOTATION_10E18 = 10 ** 18;
export const NOTATION_10E16 = 10 ** 16;
export const PERCENT = 0.01;
export const PERCENT_PER_THOUSAND = 0.001;
export const HUNDRED = 100;
export const THOUSAND = 1000;
